import { render } from "./ManufacturerMaster.vue?vue&type=template&id=73daadce&scoped=true"
import script from "./ManufacturerMaster.vue?vue&type=script&lang=js"
export * from "./ManufacturerMaster.vue?vue&type=script&lang=js"

import "./ManufacturerMaster.vue?vue&type=style&index=0&id=73daadce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73daadce"]])

export default __exports__